import React from 'react';
import { CopyButton } from '../../components/button/CopyButton.tsx';
import { DrawerFieldText } from '../../components/drawer/DrawerFieldText.tsx';
import { DrawerLabel } from '../../components/drawer/DrawerLabel.tsx';
import { ITrackingEvent } from '../../support/tracking/TrackingService.ts';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { LatLngFormatPreferenceProvider } from '../LatLngFormatPreferenceProvider.ts';
import { useSubscription } from '@meraki-internal/state';
import { ICoordinate } from '../../support/model/ICoordinate.ts';
import { ToggleLatLngFormatPreferenceButton } from './ToggleLatLngFormatPreferenceButton.tsx';

export const LatLngDrawerField: React.FC<{ location?: ICoordinate; trackingEvent?: ITrackingEvent; }> = ({ location, trackingEvent }) => {
    const latLngFormatProvider = useInstance(LatLngFormatPreferenceProvider);
    useSubscription(() => latLngFormatProvider);

    const value = latLngFormatProvider.getFormattedLatLng(location);

    return (
        <>
            <DrawerLabel text="Lat / Lng" />

            <DrawerFieldText>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div data-type="lat-lng" style={{
                        fontSize: 14 // so that it doesn't cause buttons to wrap, and be consistent with weather
                    }}>
                        {value}
                    </div>
                    <div style={{
                        marginTop: -32, // shift it to line up with header Lat, Lng
                        marginBottom: -16, // prevent buttons causing space below compoent

                        // buttons were wrapping on some smaller width android devices, with longer coordinates
                        display: 'flex',
                        justifyContent: 'end'
                    }}>
                        <ToggleLatLngFormatPreferenceButton trackingFrom="map" />
                        <CopyButton
                            value={value}
                            trackingEvent={trackingEvent}
                            fill='clear'
                            size="small"
                        />
                    </div>

                </div>
            </DrawerFieldText>
        </>
    );
};
